import React from 'react'
import {useIntl} from 'react-intl'
import {DEFAULT_DATE_FILTER} from '../../../../_gori/constants'
import {DatePicker} from '../../../../_gori/helpers/components/DatePicker'
import {InputSearch, TableHeader} from '../../../../_gori/partials/widgets'
import {UploadUspsClaimsAgreementModal} from '../modals/UploadUspsClaimsAgreementModal'
import UseRoutesPermission from '../../../../_gori/hooks/UseRoutesPermission'
import {TrackingNumberClaimModal} from '../modals/TrackingNumberClaimsModal'
import {KTSVG} from '../../../../_gori/helpers'
type Props = {
  reloadTable?: any
  isLoadingExport?: any
  handleExport?: any
  showTrackingNumberClaimModal?: any
  setShowTrackingNumberClaimModal?: any
  showModalUploadUspsClaim?: any
  setShowModalUploadUspsClaim?: any
}

const ClaimsFilter: React.FC<Props> = ({
  reloadTable,
  isLoadingExport,
  handleExport,
  showTrackingNumberClaimModal,
  setShowTrackingNumberClaimModal,
  showModalUploadUspsClaim,
  setShowModalUploadUspsClaim,
}) => {
  const intl = useIntl()
  const {routes} = UseRoutesPermission()

  return (
    <>
      {routes.CLAIMS_CREATE.hasPermission && showTrackingNumberClaimModal && (
        <TrackingNumberClaimModal
          show={showTrackingNumberClaimModal}
          setShow={setShowTrackingNumberClaimModal}
          onCreateClaimsSuccessCallback={reloadTable}
        />
      )}
      <UploadUspsClaimsAgreementModal
        show={showModalUploadUspsClaim}
        handleClose={() => {
          setShowModalUploadUspsClaim(false)
        }}
        reloadTable={() => reloadTable()}
      />
      <TableHeader className='min-h-1px my-5 mb-8'>
        <div className='card-title align-items-start filter-toolbar-44 filter-full-tablet me-0'>
          <div className='d-flex align-items-start position-relative w-100'>
            <InputSearch placeholder={intl.formatMessage({id: 'TRACKING_NUMBER'})} />
          </div>
        </div>
        <div className='card-toolbar flex-row-fluid justify-content-end gap-3 align-items-start filter-toolbar-44 filter-full-tablet'>
          <div className='filter-eight-tenths'>
            <DatePicker
              className='bg-input-dark filter-full-mobile'
              name={intl.formatMessage({id: 'REQUEST_DATE'})}
              dateStart={DEFAULT_DATE_FILTER.CLAIMS}
              justifyContent='start'
            />
          </div>
          <div
            className='btn bg-input-dark fw-bolder align-content-center filter-grow-tablet filter-full-mobile'
            onClick={() => handleExport()}
          >
            <KTSVG path='/media/gori/account/download.svg' className='svg-icon-2' />
            {intl.formatMessage({id: 'EXPORT_CLAIM_LIST'})}
            {isLoadingExport && (
              <div className='ms-2 spinner-border spinner-border-sm' role='status' />
            )}
          </div>
        </div>
      </TableHeader>
    </>
  )
}

export {ClaimsFilter}
